<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.account"
              placeholder="账号"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.accountType"
              clearable
              placeholder="账号类型"
              style="width: 100%;"
            >
              <el-option
                label="睿零售用户电话"
                :value="1"
              />
              <el-option
                label="群成员微信号"
                :value="2"
              />
              <el-option
                label="调研问卷用户ID"
                :value="3"
              />
              <el-option
                label="专卖证号"
                :value="4"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.offsetResult"
              clearable
              placeholder="核销结果"
              style="width: 100%;"
            >
              <el-option
                label="成功"
                :value="1"
              />
              <el-option
                label="失败"
                :value="2"
              />
              <el-option
                label="未核销"
                :value="3"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-visible.sync="dialogViewVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 查看
import viewDialog from './components/viewDialog';
// 成长值核销明细API
import { loadGrowthValueOffsetDetailListDataApi, exportGrowthValueOffsetDetailListDataApi } from "@/api/v2/growthValueOffsetDetail";

export default {
  name: 'GrowthValueOffsetDetailView',
  components: { CustomTable2, TableOperation2, viewDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'growth_value_offset_detail_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['growth_value_offset_detail_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['growth_value_offset_detail_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          account: '',
          accountType: '',
          offsetResult: '',
        },
      },
      id: null,
      dialogMatchVisible: false,
      dialogViewVisible: false,
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80, align: 'center' },
      { prop: 'provinceName', label: '省区', filterColumn: 'tgvo.province_name', width: 90 },
      { prop: 'name', label: '核销名称', filterColumn: 'tgvo.name', minWidth: 240 },
      { prop: 'accountTypeValue', label: '账号类型', filterColumn: "(case tgvod.account_type when 1 then '睿零售用户电话' when 2 then '群成员微信号' when 3 then '调研问卷用户ID' when 4 then '专卖证号' else '' end)", width: 120 },
      { prop: 'account', label: '账号', filterColumn: 'tgvod.account', width: 180 },
      { prop: 'growthValue', label: '核销成长值', filterColumn: 'tlse.growth_value', width: 120 },
      { prop: 'offsetGrowthValueTime', label: '执行核销时间', filterColumn: 'tgvo.offset_growth_value_time', width: 150 },
      { prop: 'offsetResultValue', label: '成长值核销结果', filterColumn: "(case tgvod.offset_result when 1 then '成功' when 2 then '失败' else '未核销' end)", width: 140 },
      { prop: 'failReason', label: '成长值核销失败原因', filterColumn: 'tgvod.fail_reason', width: 300 },
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadGrowthValueOffsetDetailListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 查看
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的成长值核销明细', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportGrowthValueOffsetDetailListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
